export default function MotorikCircle(props) {
  return (
    <svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20z"
        fill="#F65703"
      />
      <g clipPath="url(#clip0_4359_85440)">
        <path
          d="M25.071 11.667h-.095l-4.929 4.107-4.929-4.107h-.094L10 15.834v12.5h5.118v-10.9l4.93 4.107 4.928-4.108v10.9h5.119v-12.5l-5.024-4.166z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="clip0_4359_85440">
          <path fill="#fff" transform="translate(10 10)" d="M0 0H20V20H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
